export const createOptionId = (groupIdx, optionIdx) => `${groupIdx}__${optionIdx}`;